


































































import { Vue, Component, Prop } from 'vue-property-decorator';
import VueRecaptcha from 'vue-recaptcha';
import axios from 'axios';

interface Contact {
  name: string;
  email: string;
  company: string;
  message: string;
}
const API_ENDPOINT = ' https://noaa38d515.execute-api.us-east-1.amazonaws.com/dev/chrcnlDemoRequest';

@Component({
  components: {
    VueRecaptcha,
  },
})
export default class DemoRequest extends Vue {
  // Data
  @Prop({ default: false }) navBar!: string;

  sheet = false;

  snackbar = false;

  contact: Contact = {
    name: '',
    email: '',
    company: '',
    message: '',
  };

  // Methods
  submit(formResponse): void {
    if (!formResponse) { return; }
    const params = { contact: this.contact };
    axios
      .post(API_ENDPOINT, params)
      .then((response) => {
        this.sheet = false;
        this.snackbar = true;
      })
      .catch((error) => {
        console.log(error);
      });
  }

  contactClicked(): void {
    this.sheet = true;
  }
}
